import {launchDarkly} from 'utils/launchDarkly';

// swaps the legacy reactabular table for the ag-grid rendering of the same column map
export const AG_GRID_TABLE_FLAG = 'use-ag-grid-table';

// the grid's date filter only exists as the new calendar, so this is a prerequisite
export const NEW_CALENDAR_FLAG = 'fe-use-new-calendar';

/** Read at render: the pages switching on it are class components with no wrapper to hold it. */
export const isAgGridTableEnabled = (): boolean =>
    (launchDarkly.userClient?.variation(AG_GRID_TABLE_FLAG, false) ?? false)
    && (launchDarkly.userClient?.variation(NEW_CALENDAR_FLAG, false) ?? false);
